<template>
<div>


  <!-- <h1>Profile: {{ msg }}</h1>
  <br> -->

  <!-- <section>
    <b-button @click="clickMe" type="is-success">Click Me</b-button>
  </section> -->

  <!-- {{allEvents}}
  =================
  {{testevents}} -->

  <!-- {{localAllEvents}} -->

  <!-- {{eventsToShow}} -->
  

  <section>

    <!-- <h2>{{pickeddate}}</h2> -->
    <b-field>
      <div class="control">
          <b-switch v-model="isRange">Select Range</b-switch>
      </div>
    </b-field>

    <b-field v-if="!isRange" style="margin:2em;" >

      <b-datepicker
            inline
            v-model="pickeddate" 
            :events="localAllEvents"
            :indicators="indicators"
            >
        </b-datepicker>

    </b-field>

    <b-field v-if="isRange" style="margin:2em;">

      <b-datepicker
            inline
            v-model="pickeddate" 
            :events="localAllEvents"
            :indicators="indicators"
            range
            >
        </b-datepicker>

    </b-field>

    <!-- {{pickeddate}}
    {{localFilteredEvents}} -->

    <!-- <div v-for="(event, index) in localFilteredEvents" :key="index"> 
      {{event.id}}
      </div> -->

    <!-- ======= TABLE ======= -->

    <b-field>
      <div class="control">
          <b-switch v-model="showDetailIcon">Icon</b-switch>
      </div>
    </b-field>

    <b-table
        :data="localFilteredEvents"
        :mobile-cards=true
        :focusable=true
        :default-sort="[sortField, sortOrder]"
        ref="table"
        detailed
        detail-key="id"
        :show-detail-icon="showDetailIcon"
        paginated
        per-page="10"
        >
        <template slot-scope="props">
            <!-- <b-table-column field="id" label="ID" width="40" numeric>
                {{ props.row.id }}
            </b-table-column> -->

            <b-table-column field="tag" label="Tag">
                <template v-if="showDetailIcon">
                    {{ props.row.etag | truncate(10) }}
                </template>
                <template v-else>
                    <a @click="toggle(props.row)">
                        {{ props.row.etag | truncate(10) }}
                    </a>
                </template>
            </b-table-column>

            <!-- <b-table-column field="tag" label="Tag" sortable>
                {{ props.row.etag }} 
            </b-table-column> -->

            <b-table-column field="summary" label="Summary">
                {{ props.row.summary | truncate(15) }} 
            </b-table-column>

            <!-- <b-table-column field="description" label="Description" sortable>
                {{ props.row.description | truncate(20) }}
            </b-table-column> -->

            <!-- <b-table-column field="comment" label="Comment" width="300">
                {{ props.row.comment | truncate(35) }}
            </b-table-column> -->

            <b-table-column field="date" label="Date" centered sortable>
                <span class="tag is-success">
                    {{ new Date(props.row.date).toLocaleDateString() }}
                </span>
            </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
            <article class="media">
                <!-- <figure class="media-left">
                    <p class="image is-64x64">
                        <img src="/static/img/placeholder-128x128.png">
                    </p>
                </figure> -->
                <div class="media-content">
                    <div class="content">
                        <p>
                            <strong>{{ props.row.etag }} </strong>
                            <br>
                            
                            <strong>{{ props.row.summary }}</strong>
                            <br>
                            <!-- <small>31m</small> -->
                            <small>Description: {{ props.row.description }} </small>
                            <!-- <small>31m</small> -->
                            <br>
                            Start: {{new Date(props.row.start.date).toLocaleDateString()}} | {{new Date(props.row.start.dateTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}
                            <br>
                            End: {{new Date(props.row.end.date).toLocaleDateString()}}  | {{new Date(props.row.end.dateTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}
                            <br>




                            Attendees:
                            <b-field grouped group-multiline>
                              <div v-for="att in props.row.attendees" :key="att.id">
                                <!-- <b-field style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;"> -->
                                  <div style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;">
                                    {{att.displayName}}
                                  </div>
                                <!-- </b-field> -->
                              </div>
                            
                            </b-field>
                            
                             <!-- {{props.row.attendees}} -->
                            <br>
                            AccountID: {{props.row.accountid}}
                        </p>

                        <b-button
                            @click="putSelectedEvent(props.row);"
                            icon-left="fas fa-angle-double-right"
                            type="is-primary">
                            Edit Event
                          </b-button>

                    </div>
                </div>
            </article>
        </template>

        <template slot="empty">
            <section class="section">
                <div class="content has-text-grey has-text-centered">
                    <p>
                        <b-icon
                            icon="emoticon-sad"
                            size="is-large">
                        </b-icon>
                    </p>
                    <p>No Events available. Select date to show events.</p>
                </div>
            </section>
        </template>
    </b-table>







    

  </section>

</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  const thisMonth = new Date().getMonth()
  const thisYear = new Date().getFullYear()

  export default {
    name: 'Calendar',
    data() {
      return  {
        pickeddate: null,
        date: new Date(thisYear, thisMonth, 1),
        // testevents: [
        //     {id: 1, date: new Date(thisYear, thisMonth, 2), type: 'is-link'},
        //    ... 
        // ],
        // :default-sort="[sortField, sortOrder]"
        sortField: "date",
        sortOrder: "asc",
        bars: false,

        localAllEvents: [],
        localFilteredEvents: [],
        // eventsToShow: [], //null
        isRange: true,

        showDetailIcon: true  //..for table
      }
    },
  props: {
    // msg: String,
    // pickeddate: String
  },
  created () {
    console.log("accountid of user: "+this.getUserProfile.accountid)

    // this.fetchEvents(this.getUserProfile.accountid)

    // this.fetchEvents(this.getProfile)
    // this.localAllEvents = JSON.parse(JSON.stringify(this.allEvents))
    this.localAllEvents = this.createLocalAllEvents()
    // this.setFilteredEvents()
    // this.createEventsToShow()
  },
  filters: {
      /**
      * Filter to truncate string, accepts a length parameter
      */
      truncate(value, length) {
          return value.length > length
              ? value.substr(0, length) + '...'
              : value
      }
    },
  computed: {
    ...mapGetters(['allEvents', 'selectedEvent', 'getUserProfile']), // 
    indicators() {
        return this.bars ? 'bars' : 'dots'
    },
    
  },
  methods: {
    ...mapActions(['fetchEvents', 'putSelectedEvent']),
    createLocalAllEvents () {
      console.log('create localAllEvents') //make json copy and set Date() type
      let tmpevents = []
      for (let event of this.allEvents) {
        let tmpevent = JSON.parse(JSON.stringify(event))
        tmpevent["date"] = new Date(tmpevent.start.date) // .. needed for the datepicker component (set here instead of event datamodel)
        tmpevents.push(tmpevent)
      }
      return tmpevents
    },
    setFilteredEvents () {
      // console.log('start filtering ..')
      // const localAllEvents = JSON.parse(JSON.stringify(this.allEvents))
      if (!this.isRange) {
        this.localFilteredEvents = this.localAllEvents.filter(event => event.date.getTime() === this.pickeddate.getTime())
      } else {
        this.localFilteredEvents = this.localAllEvents.filter(event => event.date >= this.pickeddate[0] && event.date <= this.pickeddate[1])
      } 
    },
    toggle(row) {
        this.$refs.table.toggleDetails(row)
    },

    // .. DATEPICKER COMPONENT NEED DATE from type new Date() / not string !!! this is done now in this.createLocalAllEvents() 
    // createEventsToShow () {
    //   for (let event of this.localAllEvents) {
    //     this.eventsToShow.push({date: new Date(event["date"]), type: event["type"] })
    //   }
    // },
  },
  watch: {
    allEvents () {
        // this.localAllEvents = JSON.parse(JSON.stringify(newValue))
        this.localAllEvents = this.createLocalAllEvents()
        // this.createEventsToShow()
        // this.setFilteredEvents()
        // console.log("watch -> allEvents @ Calendar.vue triggered")
    },
    selectedEvent () {
      this.setFilteredEvents() //.. for table update
      console.log("watch -> setFilteredEvents @ Calendar.vue triggered") 
    },
    pickeddate () {
      this.setFilteredEvents()
      console.log("watch -> pickeddate @ Calendar.vue triggered")
    }
  }
}



// function mydateFormatter (date: Date):String {
//   let options = { year: 'numeric', month: 'short', day: 'numeric' };
//   return date.toLocaleDateString('de', options);
// }

</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
